import {systemFetch, wymsFetch} from '@/utils/fetch';
import fetch from '@/utils/fetch';
/**
 * 根据id获取所在部门
 * @param {*} userId 
 * @param {*} depType 
 */
export function queryDepartByUserId(userId, depType) {
    let params = new URLSearchParams();
    params.append('userId', userId);
    params.append('depType', depType);
    return systemFetch({
        url: 'api/user/depart/queryDepartByUserId',
        method: 'post',
        data: params
    });
}


/**
 * 获得班级列表
 */
export function querySchoolClass(args) {
    let params = new URLSearchParams();
    if(args.isExcludNewClass) {
        params.append('isExcludNewClass', args.isExcludNewClass);
    }

    return systemFetch({
        url: 'api/depart/querySchoolClass',
        method: 'post',
        data: params
    });
}

/**
 * 获得年级列表
 */
export function querySchoolGrade() {
    return systemFetch({
        url: 'api/depart/querySchoolGrade',
        method: 'post'
    });
}

/**
 * 获得所教班级和年级(班级里包含年级信息)
 */
export function queryClassGrade() {
    return systemFetch({
        url: 'api/teacherClass/queryClassGrade',
        method: 'post'
    });
}
/**
 * 根据老师ID获得所教班级和所带班级
 */
export function queryAllClassCourse() {
    let params = new URLSearchParams();
    return systemFetch({
        url: 'api/teacherClass/queryAllClassCourse',
        method: 'post'
    });
}
/**
 * 根据年级获得课程(查询年级下的班级，老师所教这些班级的课程)
 * 
 */
export function queryCourseByGradeId(gradeId) {
    let params = new URLSearchParams();
    params.append('gradeId', gradeId);
    return systemFetch({
        url: 'api/teacherClass/queryCourseByGradeId',
        method: 'post',
        data: params
    });

}

/**
 * 根据班级ID获得课程(根据当前登录用户ID和班级ID（多个逗号分隔），查询去重后的课程)
 * @param {*} classIdsStr 
 */
export function queryCourseByClassIds(classIdsStr) {
    let params = new URLSearchParams();
    params.append('classIdsStr', classIdsStr);
    return systemFetch({
        url: 'api/teacherClass/queryCourseByClassIds',
        method: 'post',
        data: params
    });
}


/**
 * 查询学校所有学期列表
 */
export function getSchoolTimeAllList() {

    return systemFetch({
        baseURL: global.BasePath,
        url: 'structure/schoolTime/getSchoolTimeAllList',
        method: 'post'
    });
}



/**
 * 根据班级ID获取负责人wxcepClient1/depart/queryManager
 * @param {*} classIdsStr 
 */
export function queryManager(departId) {
    let params = new URLSearchParams();
    params.append('departId', departId);
    return systemFetch({
        url: 'api/depart/queryManager',
        method: 'post',
        data: params
    });
}

/**
 * 根据字典code获得字典数据
 * @param {*} dicCode 
 */
export function findDicsByCode(dicCode){
    let params = new URLSearchParams();
    params.append('dicCode', dicCode);
    return systemFetch({
        baseURL: global.BasePath,
        url: 'structure/sysDictionary/findDicsByCode',
        method: 'post',
        data: params
    });
}

/**
 * 根据id获取用户角色userRole/queryRoleList
 * @param {*} parentId, studentId
 */
export function queryRoleList(userId) {
    let params = new URLSearchParams();
    params.append('userId', userId);
    return systemFetch({
        url: 'api/user/role/queryRoleList',
        method: 'post',
        params
    });
}

/*邀请函*/
export function invitationIndex(query){
    let params = new URLSearchParams();
    params.append('departId', query.departId);
    return systemFetch({
        url: 'sys/invitation/index',
        method: 'get',
        params
    });
}
/*日志管理分页查询日志*/
export function recordByType(query){
    let params = new URLSearchParams();
    params.append('begin_date', query.begin_date);
    params.append('end_date', query.end_date);
    params.append('operationName', query.operationName);
    params.append('pageNo', query.pageNo);
    params.append('pageSize', query.pageSize);
    params.append('type', query.type);
    return systemFetch({
        url: 'sys/operation/recordByType',
        method: 'get',
        params
    });
}
/*用户分析首页*/
export function statisticsSchool(){
    let params = new URLSearchParams();
    return systemFetch({
        url: 'sys/statistics/school/index',
        method: 'get'
    });
}

/*用户数据统计动态查询*/
export function getUserCount(query){
    let params = new URLSearchParams();
    params.append('days', query.days);
    params.append('endDate', query.endDate);
    params.append('startDate', query.startDate);
    return systemFetch({
        url: 'sys/statistics/school/getUserCount',
        method: 'get',
        params
    });
}

/*用户登录统计动态查询*/
export function getUserLoginCount(query){
    let params = new URLSearchParams();
    params.append('days', query.days);
    params.append('endDate', query.endDate);
    params.append('startDate', query.startDate);
    return systemFetch({
        url: 'sys/statistics/school/getUserLoginCount',
        method: 'get',
        params
    });
}
/*模块使用总量分析*/
export function statisticsTotalListPage(query){
    let params = new URLSearchParams();
    return fetch({
        url: 'modulestatistics/statisticsTotalListPage',
        method: 'get'
    });
}
/*每个模块使用分析*/
export function statisticsList(query){
    let params = new URLSearchParams();
    params.append('days', query.days);
    params.append('startDate', query.startDate);
    params.append('endDate', query.endDate);
    params.append('moduleCode', query.moduleCode);
    return systemFetch({
        url:'sys/modulestatistics/statisticsList',
        method: 'get',
        params
    })
}

/*学校已安装的应用列表*/
export function moduleManageIndex(query){
    let params = new URLSearchParams();
    params.append('moduleName', query.moduleName);
    return systemFetch({
        url: 'sys/module/index',
        method: 'get',
        params
    });
}
/*查看应用角色*/
export function roleSee(query){
    let params = new URLSearchParams();
    params.append('moduleCode', query.moduleCode);
    return systemFetch({
        url: 'sys/module/roleSee',
        method: 'get',
        params
    });
}
/*部门主任首页*/
export function master(query){
    let params = new URLSearchParams();
    params.append('name',query.name);
    params.append('type',query.type);
    return systemFetch({
        url:'sys/depart/master',
        method:'get',
        params
    })
}
/*修改部门负责人*/
export function masterUpdate(query){
    let params = new URLSearchParams();
    params.append('departId',query.departId);
    params.append('managerOtherUserIds',query.managerOtherUserIds);
    params.append('managerUserId',query.managerUserId);
    return systemFetch({
        url:'sys/depart/master/update',
        method:'get',
        params
    })
}

//
export function logList(args) {
    let params = new URLSearchParams();
    params.append('beginDate', args.beginDate);
    params.append('endDate', args.endDate);
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);
    params.append('searchVal', args.searchVal);
    params.append('type', args.type);

    return wymsFetch({
        url:'wyOperationLog/logList',
        method: 'POST',
        data: params
    })
}

// 日志列表页
export function pushRecordLogList(args) {
    let params = new URLSearchParams();
    params.append('appName', args.appName);
    params.append('startDateTime', args.startDateTime);
    params.append('endDateTime', args.endDateTime);
    params.append('httpResultCode', args.httpResultCode);
    params.append('messageId', args.messageId);
    params.append('schoolName', args.schoolName);
    params.append('operationType', args.operationType);
    params.append('result', args.result);
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);
    if(args.eventType){
        params.append('eventType', args.eventType);
    }
    params.append('serachContentVal', args.serachContentVal);

    return systemFetch({
        url:'log/push/queryByPage',
        method: 'POST',
        data: params
    })
}

// 重试
export function retryPush(args) {
    return systemFetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'log/push/retryPush',
        method: 'POST',
        data: JSON.stringify([args.id])
    });
}

// 已处理
export function updatePushtState(args) {
    return systemFetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'log/push/markSuccess',
        method: 'POST',
        data: JSON.stringify([args.id])
    });
}


//分页查询数据
export function queryByPage(args) {
    let params = new URLSearchParams();
    params.append('beginTime', args.beginTime);
    params.append('dataName', args.dataName);
    params.append('endTime', args.endTime);    
    params.append('pageSize', args.pageSize);
    params.append('pageNo', args.pageNo);
    if(args.opnType){
        params.append('opnType', args.opnType);
    }
    if(args.dataSubjectType){
        params.append('dataSubjectType', args.dataSubjectType);
    }
    if(args.pushStatus!=-1){
        params.append('pushStatus', args.pushStatus);
    }   
    params.append('schoolInfo', args.schoolInfo);
    return systemFetch({
        url:'log/basicData/queryByPage',
        method: 'get',
        params
    })
}


/*查询 操作对象 的下拉列表*/
export function querySubjectTypeEnum(){
    return systemFetch({
        url:'log/basicData/querySubjectTypeEnum',
        method:'get'
    })
}

/*查询 操作类型 的下拉列表*/
export function queryOpnTypeEnum(subjectType){
    let params = new URLSearchParams();
    params.append('subjectType',subjectType);
    return systemFetch({
        url:'log/basicData/queryOpnTypeEnum',
        method:'get',
        params
    })
}


// WEBPACK FOOTER //
// ./src/api/system.js